import AttributeCookies from '../components/AttributeSelector/helpers/AttributeCookies';
import getValueFromWindow from './getValueFromWindow';


const getCommodityValue = () => {
  const filterKey = 'commodity';

  let attributeValue;
  const currentOptionKey = (new AttributeCookies()).getChildValue(filterKey);

  const filteringAttributes = getValueFromWindow('attribute_selector', 'filteringAttributes');
  if (!filteringAttributes) {
    return null;
  }

  const commodityFilter = filteringAttributes.find((attr) => attr.filter === filterKey);
  if (!commodityFilter) {
    return null;
  }

  const currentOption = currentOptionKey && commodityFilter.options
    .find(option => option.value === currentOptionKey);

  attributeValue = currentOption && currentOption.value;

  if (!attributeValue) {
    const defaultOption = commodityFilter.options.find((option) => option.default);
    if (defaultOption) {
      attributeValue = defaultOption.value;
    }
  }
  
  return attributeValue;
};

export default getCommodityValue;
